<template>
    <div class="home">
        <div class="homeleft">
            <div class="homeleftt">
                <div class="homeleftti"><img src="../../assets/zhuhahome.png"> </div>
                <div class="homeleftts">
                    助花总服务台
                </div>
            </div>
            <div class="feature" v-for="(item, index) in admins">
                <div class="features">
                    <div class="featurest" :id="'featurest' + index" @click="goyun(item)"
                        :class="bgc == item.permName ? 'bgc' : ''" :key="index">

                        <div style="margin-right: 10px;height: 24px;">
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="guanli"
                                v-if="item.permId == 'c531d0d05dc4d81dbf916d5a349f0941'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="vip"
                                v-if="item.permId == 'c2080741ecfe5d1c9edf831a57144a75'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="store"
                                v-if="item.permId == 'c8b3636ccb6cbb813b5a31f248fe8088'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="dinbgdan"
                                v-if="item.permId == 'a901efae1759051f012ebcb528f0eb2a'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="huodong"
                                v-if="item.permId == '161fcbf5b1ec0321610fc334a39c749f'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="moban"
                                v-if="item.permId == '246e888b686bda15760faceb1c484706'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="zhijing"
                                v-if="item.permId == '611c25c2e7dde3110837f48711d86793'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="goody"
                                v-if="item.permId == '44bca9dd232a13077d93874bb1cae28a'"></SvgIcon>
                            <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="fenxaio"
                                v-if="item.permId == 'ff5067c5c99280b81e2d2686e9c98312'"></SvgIcon>
                        </div>
                        <div> {{ permName(item.permName) }} &nbsp;&nbsp; <span
                                v-show="item.permId == '161fcbf5b1ec0321610fc334a39c749f' || item.permId == 'c531d0d05dc4d81dbf916d5a349f0941'"><el-icon>
                                    <ArrowDown />
                                </el-icon></span>
                        </div>
                        <!-- <img src="../assets/icons/svg/guanli.svg" alt=""> -->

                    </div>
                    <div class="featuresd2" v-if="item.permId == 'c531d0d05dc4d81dbf916d5a349f0941'">
                        <div class="featuress" :class="changis == 1 ? 'getcolor' : ''" @click="goodlistgo">商品列表管理</div>
                        <div class="featuress" :class="changis == 2 ? 'getcolor' : ''" @click="guogego">规格模板管理</div>
                        <div class="featuress" :class="changis == 5 ? 'getcolor' : ''" @click="pingpai">商品品牌管理</div>

                    </div>
                    <div class="featuresd" v-if="item.permId == '161fcbf5b1ec0321610fc334a39c749f'">

                        <div class="featuress" :class="changis == 3 ? 'getcolor' : ''" @click="chang">运营场次管理</div>
                        <div class="featuress" :class="changis == 4 ? 'getcolor' : ''" @click="goods">运营商品管理</div>
                    </div>
                </div>
            </div>
            <div class="homeleftd">
                <div class="homeleftds" @click="gointall" :class="bgc == 'intall' ? 'bgc' : ''">

                    <div class="hiocn"><el-icon :size="20">
                            <Setting />
                        </el-icon></div>
                    <div>设置</div>
                </div>
                <div class="homeleftds" @click="logout">
                    <div class="hiocn">
                        <img style="width: 24px;height: 24px;" src="../../assets/itex.png" alt="">
                    </div>
                    <div>退出登录</div>
                </div>
            </div>
        </div>
        <div class="homeright" v-if="pubilsh == 1">

            <MengPublish></MengPublish>
        </div>
        <div class="homeright" v-if="pubilsh == 2">

            <FenPubilsh></FenPubilsh>
        </div>
        <div class="homeright" v-if="pubilsh == 3">
            <Linyuan></Linyuan>
        </div>
    </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import api from '@/api/api';
// import '@wangeditor/editor/dist/css/style.css' // 引入 css

import { ref, onMounted, onUnmounted } from 'vue'

import { useStore } from 'vuex';
// import {} from 'vue-router';
import MengPublish from '@/components/publish/MengPublish.vue';
import FenPubilsh from '@/components/publish/FenPubilsh.vue';
import Linyuan from '@/components/publish/Linyuan.vue';

const route = useRoute()

const store = useStore();
const tanme = ref([])
const tid = ref([])
const pipailist = ref([])
const pubilsh = ref(null)
let productGoods = []
// const 
let changis = ref(null)
const goodlistgo = () => {
    changis.value = 1
    router.push('/home/goodlist')
}
const guogego = () => {
    changis.value = 2
    router.push('/home/standard')

}
const chang = () => {
    changis.value = 3
    router.push('/home/events/chang')
}
const goods = () => {
    changis.value = 4
    router.push('/home/events/goods')
}
onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
onMounted(() => {
    console.log('route.query', route.query)
    tanme.value = route.query.tanme
    tid.value = route.query.tid
    pubilsh.value = route.query.pubilsh
    qunxain()
    storeBrand()
    productGoodsType()
    freightTemplate()
    window.addEventListener('scroll', handleScroll);
    setTimeout(() => {
        valueHtml.value = ''
    }, 1500)
})
const freighttlist = ref([])
const freightTemplate = async () => {
    let data = {
        storeId: 77,
        pageSize: 999
    }
    const res = await api.freightTemplates(data)
    console.log('freightTemplate', res)
    if (res.success) {
        freighttlist.value = res.data.tlist
    }
}
const storeBrand = async () => {
    const res = await api.storeBrand()
    console.log('storeBrand', res)
    pipailist.value = res.data.tlist
}
const productGoodsType = async () => {
    const res = await api.productGoodsType()
    productGoods = res.data.map(item => {
        return { ...item, value: item.typeName };
    });
    console.log('productGoodsType', productGoods)


}

const handleScroll = (event) => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    // console.log(scrollTop, '滚动距离')
    gunlin(scrollTop)

}
const gunlin = (y) => {
    const procedure = document.querySelector('.procedure')
    procedure.style.top = y + 'px'
}
// 内容 HTML
const valueHtml = ref('')

// 模拟 ajax 异步获取内容

let admins = ref()
const qunxain = () => {
    let adminPermList
    let adminPermLists
    let admin
    if (localStorage.getItem('usermassage') && JSON.parse(localStorage.getItem('usermassage')).adminPermList != null) {
        adminPermList = JSON.parse(localStorage.getItem('usermassage'))
        adminPermLists = adminPermList.adminPermList
        console.log('adminPermList', adminPermLists)
        admin = adminPermLists.filter(item => item.permPathLevel == 1 && item.permName != "管理账号" && item.permName != "后台设置" && item.permName != "规格模板")
        console.log('qunxain', admin)
        admins.value = admin
    }
}
const permName = (name) => {
    if (name == '商品权限') {
        return '商品管理'
    } else if (name == '店铺') {
        return '商铺管理'
    } else if (name == '会员管理') {
        return '会员管理'
    } else if (name == '订单权限') {
        return '助花订单'
    } else if (name == '活动运营管理') {
        return '运营管理'
    } else if (name == '运费模板') {
        return '运费模板'
    } else if (name == '规格模板') {
        return '规格模板'
    } else if (name == '资金管理') {
        return '资金管理'
    }
    else if (name == '礼包管理') {
        return '会员礼包'
    }
    else if (name == '分销码') {
        return '分销详情'
    }
}
const pingpai = () => {
        router.push('/home/goodlist/PinList')

        changis.value = 5
    }
let isyun = true
let stopyun = true

const goyun = (item) => {
    store.commit('sethomebgc', item.permName);
    const featuresdElements = document.querySelector('.featuresd');
    const featuresdElements2 = document.querySelector('.featuresd2');

    if (item.permId == '161fcbf5b1ec0321610fc334a39c749f') {
        bgc.value = item.permName
        if (isyun) {
            isyun = false
            // console.log('featuresdElements', featuresdElements)
            featuresdElements.classList.add('expanded');
            console.log(item)
        } else {
            isyun = true
            featuresdElements.classList.remove('expanded');
        }
    } else if (item.permId == 'c531d0d05dc4d81dbf916d5a349f0941') {
        bgc.value = item.permName
        if (stopyun) {
            stopyun = false
            // console.log('featuresdElements', featuresdElements)
            featuresdElements2.classList.add('expanded');
            console.log(item)
        } else {
            stopyun = true
            featuresdElements2.classList.remove('expanded');
        }
    }
    else {
        isyun = true
        stopyun = true
        featuresdElements.classList.remove('expanded');
        bgc.value = item.permName
        router.push(item.permPath)
        console.log(bgc.value)
    }

    
}
const router = useRouter();
const bgc = ref('gogoods')
const logout = async () => {
    const res = await api.logout()
    if (res.success) {
        router.push('/login')

    }
}
const gointall = () => {
    bgc.value = 'intall'

    router.push('/home/install/installData')

}
</script>

<style lang="scss" scoped>
ol,
ul {
    list-style: none;
}

input {
    outline: none;
    border: 1px solid #D9D9D9;
    height: 32px;
    padding-left: 12px;
}

select {
    outline: none;
    border: 1px solid #D9D9D9;
    height: 32px;
    padding-left: 12px;

    .option {
        border-radius: 0px;
        height: 20px;
    }

}

.home::after {
    content: "";
    clear: both;
    display: block;
}

html,
body {
    height: 100% !important;
}


.home {
    height: 100%;
    min-width: 1440px;
    padding: 17px 32px 58px 20px;
    background-color: #F2F8FC;
    display: flex;

    .bgc {
        background: #DAEFFF;
        color: #0091FF !important;
        font-weight: 500;
    }

    .homeleft {

        width: 200px;

        padding-top: 23px;
        background-color: #FFFFFF;
        border-radius: 16px;
        margin-right: 22px;
        position: relative;

        .homeleftt {
            width: 100%;
            height: 97px;
            display: flex;
            align-items: center;

            .homeleftti {
                margin: 0 12px 0 18px;
                width: 40px;
                height: 40px;

                // background-color: #D4D4D4;
                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .homeleftts {
                font-size: 18px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.88);
            }
        }

        .features {
            // line-height: 42px;
            // height: 42px;
            color: #718096;

            margin-bottom: 20px;

            .featurest {
                padding-left: 28px;
                box-sizing: border-box;
                height: 42px;
                display: flex;
                align-items: center;
                cursor: pointer;
                transition: color 0.5s, background-color 0.5s;

            }

            .featurest:hover {
                background: #DAEFFF;
                color: #0091FF !important;

            }

            .featuresd {
                height: 0;
                overflow: hidden;

                transition: height 0.5s;

                // background-color: #c42323;

                .featuress {
                    height: 40px;
                    background-color: #fff;
                    padding-left: 60px;

                    line-height: 40px;
                    box-sizing: border-box;
                    cursor: pointer;

                }

                .getcolor {
                    background-color: #f3faff;
                    color: rgb(0, 145, 255);
                }

            }

            .featuresd2 {
                height: 0;
                overflow: hidden;

                transition: height 0.5s;

                // background-color: #c42323;

                .featuress {
                    height: 40px;
                    background-color: #fff;
                    padding-left: 60px;

                    line-height: 40px;
                    box-sizing: border-box;
                    cursor: pointer;




                }

                .getcolor {
                    background-color: #f3faff;
                    color: rgb(0, 145, 255);
                }
            }

            .featuresd2.expanded {
                // display: block;
                height: 120px;

            }

            .featuresd.expanded {
                // display: block;
                height: 80px;
            }


        }

        .homeleftd {
            width: 100%;
            box-sizing: border-box;
            font-size: 16px;
            position: absolute;
            bottom: 30px;

            .homeleftds {
                color: #718096 !important;
                display: flex;
                align-items: center;
                height: 48px;
                margin-bottom: 20px;
                padding-left: 27px;

                .hiocn {
                    width: 24px;

                    margin-right: 16px;

                }
            }
        }
    }

    .homeright {

        width: calc(100% - 222px);

        .over {
            position: absolute;
            bottom: 0px;
            width: 100%;
            height: 61px;
            background: #FFFFFF;
            box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.16);
            display: flex;
            justify-content: center;
            align-items: center;


            .overs {
                display: flex;
                width: 356px;
                justify-content: space-between;

                .baochun {
                    width: 148px;
                    height: 48px;
                    background: #444444;
                    border-radius: 8px;
                    color: #FFFFFF;
                    line-height: 48px;
                    text-align: center;
                }
            }



        }

        .addtop {
            color: rgba(0, 0, 0, 0.85);
            width: 100%;
            height: 48px;
            background: #FFFFFF;
            box-shadow: 0px 3px 29px 0px rgba(196, 203, 214, 0.1);
            border-radius: 8px;
            margin-bottom: 12px;
            line-height: 48px;
            padding-left: 22px;
            box-sizing: border-box;
        }

        .goodinfo {
            width: 100%;
            background: #FFFFFF;
            border-radius: 8px;
            position: relative;

            .procedure {
                // display: none;
                position: absolute;
                background-color: #fff;
                top: 20px;

                .procedures {
                    width: 236px;
                    height: 40px;
                    line-height: 40px;
                    display: flex;
                    align-items: center;
                    padding: 0 13px 0 32px;
                    box-sizing: border-box;
                    justify-content: space-between;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.65);

                    .proceduresnub {
                        width: 19px;
                        height: 19px;
                        border-radius: 10px;
                        background: #E45B00;
                        text-align: center;
                        line-height: 19px;
                        font-size: 13px;
                        color: #FFFFFF;
                    }

                    // background: #E7F7FF;
                }
            }

            .goodinfos {
                display: flex;

                .goodinfosleft {
                    width: 236px;
                    height: 100%;
                    background-color: #fff;
                }

                .goodinfosright {
                    width: calc(100%);
                    background-color: #fff;

                    .basisinfo {
                        width: 100%;

                        border-bottom: 1px solid #707070;
                        box-sizing: border-box;
                        color: #666666;


                        .basistop {
                            font-size: 14px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            color: #2A2A2A;
                            margin: 22px 0 0 37px;
                        }

                        .goodname {
                            color: #666666;
                            margin: 16px 0 0 54px;


                            input {
                                outline: none;
                                border: 1px solid #D9D9D9;
                                width: 762px;
                                height: 32px;
                                padding-left: 12px;
                            }

                        }

                        .zhuyi {
                            font-size: 12px;
                            font-weight: 400;
                            color: #C1C1C1;
                            margin: 7px 0 0 140px;
                        }

                        .property {
                            margin: 32px 0 38px 54px;

                            .propertys {
                                width: 831px;
                                height: 79px;
                                margin-top: 16px;
                                background: #F7F7F7;
                                border: 1px solid rgba(112, 112, 112, 0.1);
                                display: flex;
                                align-items: center;
                                padding-left: 21px;

                                .propertys1 {
                                    margin-right: 30px;

                                    input {
                                        width: 125px;
                                    }

                                    select {
                                        width: 173px;
                                        color: #C1C1C1;
                                        font-size: 11px;
                                    }
                                }


                            }


                        }
                    }



                    .Sales {
                        transition: transform 0.3s ease-in-out;
                        color: #666666;

                        .Salest {
                            margin: 28px 0 0 37px;
                            font-size: 14px;
                            font-weight: 600;

                            line-height: 20px
                        }

                        .stext {
                            margin: 19px 0 0 40px;
                            font-size: 14px;
                        }

                        .kuanshi {
                            width: 500px;
                            margin: 0 24px 0 128px;

                            .colorchoose {
                                width: 100%;
                                display: flex;
                                align-items: center;

                            }

                        }

                        .stable {
                            margin: 7px 0 0 120px;

                            table {
                                border-collapse: collapse;

                                thead {
                                    th {
                                        padding: 7px;
                                        border: 1px solid rgba(112, 112, 112, 0.16);

                                        .tatext {
                                            width: 90px;
                                            height: 32px;
                                            border: 1px solid #D9D9D9;
                                            font-size: 11px;
                                            line-height: 32px;

                                        }
                                    }


                                }

                                tbody {
                                    td {
                                        width: 100px;
                                        padding: 7px;
                                        border-right: 1px solid rgba(112, 112, 112, 0.16);
                                        box-sizing: border-box;

                                        .setupimg {
                                            width: 80px;
                                            height: 30px;
                                            // background: #F2F3F5;
                                            position: relative;

                                            .images {
                                                position: absolute;
                                                top: 0;
                                                left: 0;
                                                width: 100%;
                                                height: 100%;
                                                overflow: hidden;
                                                // video{
                                                //     width: 100%;
                                                //     height: 100%;
                                                // }
                                            }

                                            .jia {
                                                position: absolute;
                                                cursor: pointer;
                                                width: 100%;
                                                top: 50%;
                                                left: 50%;
                                                transform: translate(-50%, -50%);
                                            }

                                            .seimg {

                                                width: 80px;
                                                height: 80px;

                                                input {
                                                    padding: 0;
                                                    width: 100%;
                                                    height: 100%;
                                                    opacity: 0;
                                                }
                                            }

                                            .tioajian {
                                                width: 80px;
                                                height: 23px;
                                                background: #8F8F8F;
                                                font-size: 11px;
                                                line-height: 23px;
                                                text-align: center;
                                                font-weight: 400;
                                                color: #FFFFFF;
                                            }
                                        }

                                        input {
                                            width: 70%;
                                        }
                                    }

                                    :last-child {
                                        border: none;

                                    }
                                }
                            }
                        }

                        .xiaobiao {
                            margin: 52px 0 0 0;
                            font-size: 14px;
                            border-bottom: 1px solid #707070;
                            padding-bottom: 25px;

                            input {
                                width: 456px;
                                height: 32px;

                            }

                            form {
                                margin-left: 123px;

                                .form-example {

                                    margin-top: 17px;

                                    label {
                                        display: inline-block;
                                        width: 90px;
                                        text-align: right;
                                    }

                                }
                            }


                        }

                    }

                    .tuwen {
                        font-size: 13px;
                        font-weight: 400;
                        color: #666666;
                        border-bottom: 1px solid #707070;
                        padding-bottom: 28px;

                        .setupimgs {
                            display: flex;
                            justify-content: space-between;
                            margin: 4px 0 0 100px;
                            width: 600px;

                            .setupimg {
                                width: 80px;
                                height: 80px;
                                background: #F2F3F5;
                                position: relative;

                                .images {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    overflow: hidden;
                                    // video{
                                    //     width: 100%;
                                    //     height: 100%;
                                    // }
                                }

                                .jia {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                }

                                .seimg {

                                    width: 80px;
                                    height: 80px;

                                    input {
                                        padding: 0;
                                        width: 100%;
                                        height: 100%;
                                        opacity: 0;
                                    }
                                }

                                .tioajian {
                                    width: 80px;
                                    height: 23px;
                                    background: #8F8F8F;
                                    font-size: 11px;
                                    line-height: 23px;
                                    text-align: center;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                            }
                        }



                        .tuwenS {
                            margin: 28px 0 0 37px;
                            font-size: 14px;
                            font-weight: 600;

                            line-height: 20px
                        }

                        .tutext {
                            margin: 25px 0 0 46px;
                        }

                        .tuchaote {
                            margin: 41px 0 0 54px;
                            display: flex;


                        }

                    }

                    .wuliu {
                        font-size: 14px;
                        font-weight: 400;
                        border-bottom: 1px solid #707070;
                        padding-bottom: 40px;

                        .wutop {
                            margin: 28px 0 0 37px;
                            font-size: 14px;
                            font-weight: 600;
                            color: #2A2A2A;
                            line-height: 20px
                        }

                        .wufangs {
                            display: flex;
                            margin: 16px 0 0 37px;

                            .wumo {
                                width: 831px;
                                height: 79px;
                                color: #666666;
                                background: #F7F7F7;
                                border: 1px solid rgba(112, 112, 112, 0.10);
                                padding: 22px 0 0 23px;
                                margin-top: 17px;
                                box-sizing: border-box;

                                input {
                                    width: 173px;
                                }
                            }

                            .fangs {
                                margin-top: 17px;

                                input {
                                    width: 19px;
                                    height: 19px;

                                }
                            }
                        }

                    }

                    .zhifu {
                        padding-bottom: 26px;
                        border-bottom: 1px solid #707070;


                        .zhiftop {
                            font-size: 14px;
                            font-weight: 600;
                            color: #2A2A2A;
                            margin: 22px 0 0 34px;
                        }

                        .zhixuan {
                            margin-left: 100px;

                            .fangs {
                                margin-top: 17px;

                                input {
                                    width: 19px;
                                    height: 19px;

                                }
                            }
                        }

                        .youxuant {
                            margin: 11px 0 0 90px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #666666;
                        }

                        .youxuan {
                            color: #666666;
                            margin: 23px 0 0 100px;

                            .fangs {
                                margin-top: 17px;

                                input {
                                    width: 19px;
                                    height: 19px;

                                }
                            }

                            .mannumber {

                                width: 831px;
                                height: 79px;
                                background: #F7F7F7;
                                border: 1px solid rgba(112, 112, 112, 0.10);
                                margin-top: 14px;
                                display: flex;
                                align-items: center;
                                font-size: 14px;
                                color: #666666;

                                input {
                                    width: 173px;
                                    background-color: #fff;
                                }


                                .mancuo {
                                    div {
                                        margin-left: 15px;

                                    }

                                    display: flex;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #1890FF;

                                }
                            }



                        }
                    }

                    .Aftersale {
                        .aftert {
                            font-size: 14px;
                            font-weight: 600;
                            color: #2A2A2A;
                            margin: 22px 0 0 34px;
                        }

                        .fangs {
                            margin: 20px 0 0 90px;

                            input {
                                width: 19px;
                                height: 19px;
                            }

                            label {
                                font-size: 14px;
                                font-weight: 400;
                                color: #666666;
                            }
                        }

                        .fabu {
                            font-size: 14px;
                            font-weight: 400;
                            color: #666666;
                            display: flex;
                            align-items: center;
                            margin: 23px 0 0 50px;

                            input {
                                width: 18px;
                                height: 18px;
                            }

                            label {
                                font-size: 14px;
                                font-weight: 400;
                                color: #666666;

                            }
                        }

                    }






                }

            }


        }

    }
}
</style>